const PREFIX = 'AUTHORIZE_POPUP_';
export const SHOW_LOGIN = `${PREFIX}SHOW_LOGIN`;
export const showLoginMode = () => ({
  type: SHOW_LOGIN
});
export const SHOW_SIGNUP = `${PREFIX}SHOW_SIGNUP`;
export const showSignupMode = () => ({
  type: SHOW_SIGNUP
});